export enum GlobalActionTypes {
    SET_COORDINATES_OF_NODES = 'SET_COORDINATES_OF_NODES',
    SET_ALGORITHM = 'SET_ALGORITHM',
    RESET = 'RESET',
    START_VISUALIZATION = 'START_VISUALIZATION',
    END_VISUALIZATION = 'END_VISUALIZATION',
    SET_SPEED = 'SET_SPEED',
    UPDATE_COORDINATES = 'UPDATE_COORDINATES',
    SET_OPEN_FAB = 'SET_OPEN_FAB',
    SET_FREEZE_STATUS = 'SET_FREEZE_STATUS',
    DELETE_NODE = 'DELETE_NODE',
    INCREMENT_MAX_ID = 'INCREMENT__MAX_ID',
    INCREASE_MAX_ID = 'INCREASE_MAX_ID',
}

export default GlobalActionTypes;
